import React, { Component } from 'react';
import { Paper, Typography } from "@material-ui/core";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { connect } from 'react-redux';

class SystemDeviceFaultsPieChartInverters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartOptions: {
                chart: {
                    type: 'pie',
                    backgroundColor: null // Use default white background
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.y} errors',
                            style: {
                                color: 'black' 
                              }
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    name: 'Errors',
                    colorByPoint: true,
                    data: []
                }],
                credits: {
                    enabled: false
                }
            }
        };
    }

    componentDidMount() {
        this.processData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stationDeviceFaultData !== this.props.stationDeviceFaultData) {
            this.processData();
        }
    }

    processData = () => {
        const { deviceFaults } = this.props.stationDeviceFaultData;
        const counts = {};

        deviceFaults.forEach(item => {
            if (item.deviceName && item.distinctErrorCount) {
                counts[item.deviceName] = (counts[item.deviceName] || 0) + item.distinctErrorCount;
            }
        });

        const chartData = Object.keys(counts).map(key => ({
            name: key,
            y: counts[key]
        })).sort((a, b) => a.name.localeCompare(b.name)); // Sort alphabetically by the device name
        
        this.setState({
            chartOptions: {
                ...this.state.chartOptions,
                series: [{
                    name: 'Errors',
                    data: chartData
                }]
            }
        });
    };

    render() {
        const { loading } = this.props.stationDeviceFaultData;
        const hasData = this.state.chartOptions.series[0].data.length > 0; 

        return (
            <Paper className="SmartOMInfo">
                {/* <Typography className="SmartOMTitle" variant="h6" color="primary">
                    Fault Frequency Chart
                </Typography> */}
                <div style={{ overflowX: 'auto' }}>
                    {!loading && hasData ? (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.state.chartOptions}
                        />
                    ) : (
                        <Typography variant="subtitle1" style={{ margin: '20px' }}>
                            Data not available. Please submit to see the Frequency Pie Chart.
                        </Typography>
                    )}
                </div>
             </Paper>
        );
    }
}

const mapStateToProps = (state) => ({
    stationDeviceFaultData: state.systemDeviceFaults.queryDeviceFaultData
});

export default connect(mapStateToProps)(SystemDeviceFaultsPieChartInverters);
